<template>
  <Content>
    <div class="md-layout">
      <div class="md-layout-item md-size-530">
        <div class="md-card-perfil">
          <md-card-content>
            <div class="md-layout-item md-size-500">
              <label>Domínio Sistemas</label>

              <md-field>
                <label>Cliente ID Gerado na Contabilidade</label>
                <md-input
                  v-model="dominioSistemasIntegrationKey"
                  placeholder="Cliente ID Gerado na Contabilidade"
                />
              </md-field>

              <md-switch v-model="dominioSistemasActive">
                Ativo
              </md-switch>

              <md-button
                class="md-raised btn-atualizar-mail"
                @click="save"
              >
                Salvar
              </md-button>
            </div>
          </md-card-content>
        </div>
      </div>
    </div>
  </Content>
</template>

<script>
import { http } from '../../public/api/backend';
import Content from '../../client/public/Content.vue';
import Pagination from '../../public/pagination/Pagination.vue';

export default {
  name: 'Integrations',
  components: { Content, Pagination },

  data() {
    return {
      accountantIntegrations: {
        dominioSistemas: {
          active: false,
          configuration: { integrationKey: '' },
          integrationId: 1,
        },
      },
    };
  },

  computed: {
    dominioSistemasActive: {
      get() {
        if (
          this.accountantIntegrations &&
          this.accountantIntegrations.dominioSistemas &&
          typeof this.accountantIntegrations.dominioSistemas.active !== 'undefined'
        ) {
          return this.accountantIntegrations.dominioSistemas.active;
        }
        return false;
      },
      set(val) {
        const root = this.accountantIntegrations;

        if (!root.dominioSistemas) {
          this.$set(root, 'dominioSistemas', {
            active: val,
            configuration: { integrationKey: '' },
            integrationId: 1,
          });
          return;
        }

        root.dominioSistemas.active = val;
      },
    },

    dominioSistemasIntegrationKey: {
      get() {
        if (
          this.accountantIntegrations &&
          this.accountantIntegrations.dominioSistemas &&
          this.accountantIntegrations.dominioSistemas.configuration &&
          typeof this.accountantIntegrations.dominioSistemas.configuration
            .integrationKey !== 'undefined'
        ) {
          return this.accountantIntegrations.dominioSistemas.configuration.integrationKey;
        }
        return '';
      },
      set(val) {
        const root = this.accountantIntegrations;

        if (!root.dominioSistemas) {
          this.$set(root, 'dominioSistemas', {
            active: false,
            configuration: { integrationKey: val },
            integrationId: 1,
          });
          return;
        }

        const cfg = root.dominioSistemas.configuration;
        if (!cfg || typeof cfg !== 'object') {
          this.$set(root.dominioSistemas, 'configuration', {
            integrationKey: val,
          });
          return;
        }

        cfg.integrationKey = val;
      },
    },
  },

  async mounted() {
    await this.get();
  },

  methods: {
    async save() {
      await http.post(
        'integrations.persist-configuration',
        this.accountantIntegrations,
      );
      this.$toasted.show('Informações gravadas com sucesso!', {
        theme: 'outline',
        position: 'bottom-right',
        duration: 5000,
        type: 'success',
        icon: 'check_circle',
      });
    },

    async get() {
      const { data } = await http.post('integrations.get-configurations');
      if (!data) return;

      const list = Array.isArray(data) ? data : [data];

      list.forEach(item => {
        Object.entries(item).forEach(([name, cfg]) => {
          if (!this.accountantIntegrations[name]) {
            this.$set(this.accountantIntegrations, name, cfg);
            return;
          }
          Object.assign(this.accountantIntegrations[name], cfg);
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/accountant/integrations/Integrations.vue